module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "img-back pull-left",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', [_vm._s(_vm.msg)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page",
    class: {
      'hide': _vm.isHideStep1
    },
    staticStyle: {
      "padding-bottom": "60px"
    }
  }, [_vm._h('div', [_vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix  group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["标题："]), _vm._h('i', {
    staticClass: "red must pull-left"
  }, ["*"]), " ", _vm._h('div', {
    staticClass: "gray",
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    staticClass: "text-right font-12",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "placeholder": "点名标题"
    },
    domProps: {
      "value": _vm._s(_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  })])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "padding-15"
  }, [_vm._h('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    staticClass: "font-14 block",
    staticStyle: {
      "height": "150px"
    },
    attrs: {
      "placeholder": "备注："
    },
    domProps: {
      "value": _vm._s(_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })])])])])]), " ", _vm._h('div', {
    staticClass: "bottom-bar",
    class: {
      'hide': _vm.isHideStep1
    }
  }, [_vm._h('a', {
    staticClass: "button button-primary block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextStep()
      }
    }
  }, ["下一步，编辑名单"])]), " ", _vm._h('div', {
    staticClass: "main-page roll-edit",
    class: {
      'hide': !_vm.isHideStep1
    },
    staticStyle: {
      "padding-bottom": "60px"
    }
  }, [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideStep1 = false
      }
    }
  }, ["返回"]), " ", _vm._h('h1', ["编辑名单"]), " ", _vm._h('span', {
    staticClass: "pull-right icon-right",
    staticStyle: {
      "color": "#0cc"
    },
    on: {
      "click": function($event) {
        _vm.selectAllOrCancel()
      }
    }
  }, [_vm._s(_vm.selectFlag)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._l((_vm.serviceList), function(item) {
    return (item.list.length > 0) ? _vm._h('div', [_vm._h('span', {
      staticClass: "margin-15 block"
    }, [_vm._s(item.typeName ? item.typeName : '未添加托管服务')]), " ", _vm._h('ul', {
      staticClass: "list-group-item primary"
    }, [_vm._l((item.list), function(student) {
      return _vm._h('li', {
        staticClass: "list-group"
      }, [_vm._h('div', {
        staticClass: "liner"
      }), " ", _vm._h('a', {
        staticClass: "group-link clearfix",
        attrs: {
          "href": "javascript:;"
        }
      }, [_vm._h('span', {
        staticClass: "pull-left img-wrap small"
      }, [_vm._h('img', {
        attrs: {
          "src": item.imageAddress ? (item.baseAcessPath + item.imageAddress) : _vm.img_default,
          "width": "100%"
        }
      })]), " ", _vm._h('span', {
        staticClass: "group-txt",
        staticStyle: {
          "padding": "0",
          "height": "40px"
        }
      }, [_vm._h('span', {
        staticClass: "block overhide"
      }, [_vm._h('cite', {
        staticClass: "font-16 pull-left"
      }, [_vm._s(student.studentName)]), " ", _vm._h('i', {
        staticClass: "img-sex",
        class: {
          'boy': student.sex == '男', 'girl': student.sex == '女'
        }
      }, [_vm._s(student.sex)])]), " ", _vm._h('cite', {
        staticClass: "gray"
      }, [_vm._s((student.grade ? student.grade : '') + (student.className ? student.className : ''))])]), " ", _vm._h('span', {
        staticClass: "pull-right checkbox-wrap"
      }, [_vm._h('i', {
        staticClass: "img-checkbox",
        class: {
          'checked': student.flag
        },
        on: {
          "click": function($event) {
            student.flag = !student.flag, _vm.selectedStudent()
          }
        }
      })])])])
    })])]) : _vm._e()
  })]), " ", _vm._h('div', {
    staticClass: "bottom-bar",
    class: {
      'hide': !_vm.isHideStep1
    }
  }, [_vm._h('a', {
    staticClass: "button button-block button-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setCustomCallList()
      }
    }
  }, ["好了，生成名单"])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-511b2a1c!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/rollcall/rollcallCustom.vue
// module id = 201
// module chunks = 1